import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    TableCell,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { Close, InsertDriveFileOutlined } from "@material-ui/icons";
import { ExpandCircleDown } from "@mui/icons-material";
import { ChangeEvent, useEffect, useState } from "react";
import { Autocomplete } from "../../Autocomplete/Autocomplete";
import { PaymentHeadResponse } from "../Payments/CreatePayment/CreatePayment";
import SelectedHeadsNAmounts from "../Payments/SelectedHeadsNAmounts";

export const PaymentRow = ({
    collectee,
    collections,
    setCollections,
    checkAll,
    columnsVisibility,
    descTags,
    bank,
    headsData,
    descTagspagination,
    headsPagination,
    bankPagination,
    limit,
}: any) => {
    const [isChecked, setIsChecked] = useState(checkAll);
    const [paymentHeads, setPaymentHeads] = useState<PaymentHeadResponse[]>([]);
    const [file, setFile] = useState<{
        file: File;
        src: string;
        openPreview: boolean;
    } | null>(null);

    function handleCheck(
        event: ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) {
        setIsChecked(checked);

        setCollections((curr: any) => {
            const withCurrChecked = {
                ...curr,
                [collectee.baseUser.id]: {
                    ...collections[collectee.baseUser.id],
                    client: collectee?.baseUser?.id,
                    clinetType: collectee?.clientType?.id,
                    checked,
                },
            };

            return withCurrChecked;
        });
    }

    const handleChange = (ev: ChangeEvent<any>, id: number) => {
        setIsChecked(true);
        setCollections((curr: any) => ({
            ...curr,
            [id]: {
                ...curr[id],
                [ev.target.name]: ev.target.value,
                checked: true,
            },
        }));
    };

    const handleFile = (ev: ChangeEvent<HTMLInputElement>) => {
        if (ev.target.files && ev.target.files.length > 0) {
            const f = ev.target.files[0];
            setCollections((curr: any) => ({
                ...curr,
                [collectee.baseUser.id]: {
                    ...curr[collectee.baseUser.id],
                    file: f,
                    fileName: f.name,
                },
            }));

            setFile({
                file: f,
                src: URL.createObjectURL(f),
                openPreview: false,
            });
        }
    };

    useEffect(() => {
        setIsChecked(collections[collectee?.baseUser?.id]?.checked ?? false);
    }, [collections[collectee?.baseUser?.id]?.checked]);

    // useEffect(() => {
    //     setCollections((curr: any) => ({
    //         ...curr,
    //         [collectee.baseUser.id]: {
    //             ...collections[collectee.baseUser.id],
    //             client: collectee?.baseUser?.id,
    //             clinetType: collectee?.clientType?.id,
    //             checked: isChecked,
    //         },
    //     }));
    // }, [isChecked]);

    useEffect(() => {
        if (!collections[collectee.baseUser.id]) return;

        setPaymentHeads(collections[collectee.baseUser.id]?.heads ?? []);
    }, [collections[collectee.baseUser.id]?.heads?.length]);

    return (
        <TableRow>
            <TableCell>
                <FormControl>
                    <Checkbox checked={isChecked} onChange={handleCheck} />
                </FormControl>
            </TableCell>

            {columnsVisibility.Id && <TableCell>{collectee.id}</TableCell>}

            {columnsVisibility.Client && (
                <TableCell style={{ whiteSpace: "nowrap" }}>
                    {collectee.name}
                </TableCell>
            )}

            {columnsVisibility.Name && (
                <TableCell>
                    <TextField
                        style={{ minWidth: "220px" }}
                        multiline
                        size="small"
                        name="name"
                        label="Name"
                        value={collections[collectee.baseUser.id]?.name}
                        onChange={(ev) =>
                            handleChange(ev, collectee.baseUser.id)
                        }
                        variant="outlined"
                    />
                </TableCell>
            )}

            {columnsVisibility.Description && (
                <TableCell>
                    <TextField
                        style={{ minWidth: "280px" }}
                        multiline
                        size="small"
                        name="description"
                        label="Description"
                        value={
                            collections[collectee?.baseUser?.id]?.description
                        }
                        onChange={(ev) =>
                            handleChange(ev, collectee?.baseUser?.id)
                        }
                        variant="outlined"
                    />
                </TableCell>
            )}

            {columnsVisibility.File && (
                <TableCell style={{ minWidth: "220px" }}>
                    <Tooltip title={file ? file.file.name : ""}>
                        <Typography variant="body2">
                            {file
                                ? file.file.name.length > 10
                                    ? file.file.name.slice(0, 10) + " ..."
                                    : file.file.name
                                : "Upload Receipt"}
                        </Typography>
                    </Tooltip>
                    <IconButton size="small" component="label">
                        <InsertDriveFileOutlined />
                        <input
                            hidden
                            type="file"
                            onChange={handleFile}
                            accept="image/*,application/pdf"
                        />
                    </IconButton>

                    {file ? (
                        <IconButton
                            size="small"
                            onClick={() =>
                                setFile({ ...file, openPreview: true })
                            }
                        >
                            <ExpandCircleDown />
                        </IconButton>
                    ) : null}

                    {file ? (
                        <IconButton onClick={() => setFile(null)} size="small">
                            <Close />
                        </IconButton>
                    ) : null}

                    <Dialog
                        fullWidth
                        open={Boolean(file?.openPreview)}
                        onClose={() =>
                            setFile({ ...file, openPreview: false } as any)
                        }
                    >
                        <DialogTitle>Preview</DialogTitle>

                        <DialogContent>
                            {file && (
                                <img
                                    style={{ borderRadius: "4px" }}
                                    width="100%"
                                    alt="Receipt preview"
                                    src={file.src}
                                />
                            )}
                        </DialogContent>

                        <DialogActions>
                            <Button
                                onClick={() =>
                                    setFile({
                                        ...file,
                                        openPreview: false,
                                    } as any)
                                }
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TableCell>
            )}

            <TableCell style={{ minWidth: "220px" }}>
                <Autocomplete
                    defaultOptions={[
                        {
                            label: "Credit",
                            status: "credit",
                            id: "credit",
                        },
                        {
                            label: "Debit",
                            status: "debit",
                            id: "debit",
                        },
                    ]}
                    setOutput={(des: any) => {
                        setCollections((c: any) => ({
                            ...c,
                            [collectee.baseUser.id]: {
                                ...c[collectee.baseUser.id],
                                status: des?.status ?? "",
                            },
                        }));
                    }}
                    labelKey="label"
                    label="Target Type"
                    textFieldProps={{
                        variant: "outlined",
                        size: "small",
                    }}
                    defaultValue={
                        collections[collectee.baseUser.id]?.status
                            ? { id: collections[collectee.baseUser.id]?.status }
                            : undefined
                    }
                    clear={Boolean(
                        collections[collectee.baseUser.id]?.status == ""
                    )}
                />
            </TableCell>
            <TableCell style={{ minWidth: "220px" }}>
                <Grid item xs={6} style={{ minWidth: "220px" }}>
                    <Autocomplete
                        setOutput={(bank: any) => {
                            setCollections((c: any) => ({
                                ...c,
                                [collectee.baseUser.id]: {
                                    ...c[collectee.baseUser.id],
                                    bank: bank?.id ?? "",
                                },
                            }));
                        }}
                        labelKey="name"
                        label="Bank"
                        textFieldProps={{
                            variant: "outlined",
                            size: "small",
                        }}
                        defaultValue={
                            collections[collectee.baseUser.id]?.bank
                                ? {
                                      id: collections[collectee.baseUser.id]
                                          ?.bank,
                                  }
                                : undefined
                        }
                        clear={collections[collectee.baseUser.id]?.bank == ""}
                        defaultOptions={bank}
                        _page={bankPagination.page}
                        _limit={bankPagination.limit}
                    />
                </Grid>
            </TableCell>
            <TableCell style={{ minWidth: "220px" }}>
                <Autocomplete
                    defaultOptions={[
                        { label: "Payment", status: "payment", id: "payment" },
                        { label: "Advance", status: "advance", id: "advance" },
                        {
                            label: "Adjustment",
                            status: "adjustment",
                            id: "adjustment",
                        },
                        {
                            label: "Refund",
                            status: "refund",
                            id: "refund",
                        },
                    ]}
                    setOutput={(des: any) => {
                        setCollections((c: any) => ({
                            ...c,
                            [collectee.baseUser.id]: {
                                ...c[collectee.baseUser.id],
                                type: des?.status ?? "",
                            },
                        }));
                    }}
                    labelKey="label"
                    label="Status"
                    textFieldProps={{
                        variant: "outlined",
                        size: "small",
                    }}
                    defaultValue={
                        collections[collectee.baseUser.id]?.type
                            ? { id: collections[collectee.baseUser.id]?.type }
                            : undefined
                    }
                    clear={collections[collectee.baseUser.id]?.type == ""}
                />
            </TableCell>
            <TableCell style={{ minWidth: "220px" }}>
                <Autocomplete
                    setOutput={(_heads: PaymentHeadResponse[]) => {
                        setPaymentHeads(_heads);
                        setCollections(() => ({
                            ...collections,
                            [collectee.baseUser.id]: {
                                ...collections[collectee.baseUser.id],
                                ["heads"]: _heads,
                            },
                        }));
                    }}
                    multiple
                    labelKey="name"
                    label="Head"
                    textFieldProps={{
                        variant: "outlined",
                        size: "small",
                    }}
                    defaultValue={
                        collections[collectee.baseUser.id]?.heads
                            ? collections[collectee.baseUser.id]?.heads
                            : undefined
                    }
                    defaultOptions={headsData}
                    _page={headsPagination.page}
                    _limit={headsPagination.limit}
                />

                {paymentHeads.length ? (
                    <Grid item xs={12}>
                        <SelectedHeadsNAmounts
                            heads={paymentHeads}
                            setHeads={setPaymentHeads}
                            collections={collections}
                            collecteeId={collectee.baseUser.id}
                            setCollections={setCollections}
                        />
                    </Grid>
                ) : null}
            </TableCell>

            {columnsVisibility.DescriptionTags && (
                <TableCell style={{ minWidth: "220px" }}>
                    <Autocomplete
                        setOutput={(des: any) => {
                            setCollections(() => ({
                                ...collections,
                                [collectee.baseUser.id]: {
                                    ...collections[collectee.baseUser.id],
                                    ["descriptionTags"]: des.map(
                                        (item: any) => item
                                    ),
                                },
                            }));
                        }}
                        key={
                            collections[collectee.baseUser.id]
                                ? collections[collectee.baseUser.id]
                                : null
                        }
                        labelKey="name"
                        label="Description Tags"
                        textFieldProps={{
                            variant: "outlined",
                            size: "small",
                        }}
                        defaultOptions={descTags}
                        multiple
                        defaultValue={
                            collections[collectee.baseUser.id]?.descriptionTags
                                ? collections[collectee.baseUser.id]
                                      ?.descriptionTags
                                : undefined
                        }
                        _page={descTagspagination.page}
                        _limit={descTagspagination.limit}
                    />
                </TableCell>
            )}
        </TableRow>
    );
};
